import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';


export const AdministrationLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    styleExample: LazyLoadedStates,
    portalSettings: LazyLoadedStates,
    landing: LazyLoadedStates,
    ratingForm: LazyLoadedStates,
    alert: LazyLoadedStates,
    pvaas_upload: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.administration',
        url: '/administration',
        abstract: true
    },
    styleExample: {
        name: 'authenticated.administration.styleExample',
        url: '/styleExample',
    },
    portalSettings: {
        name: 'authenticated.administration.portalSettings',
        url: '/portalSettings'
    },
    landing: {
      name: 'authenticated.administration.landing',
      url: '/admin-landing'
    },
    ratingForm: {
      name: 'authenticated.administration.ratingform',
      url: '/rating-form-management'
    },
    alert: {
        name: 'authenticated.administration.alert',
        url: '/alert'
    },
    pvaas_upload: {
        name: 'authenticated.administration.pvaas-upload',
        url: '/pvass-upload'
    }
},
() => import('src/app/administration/administration.module').then((result: {AdministrationModule: any}) => result.AdministrationModule)
);
